export const colors = {
    brand900: '#052e16', brand800: '#14532d', brand700: '#166534',
    brand600: '#15803d', brand500: '#16a34a', brand400: '#22c55e',
    brand300: '#4ade80', brand200: '#86efac', brand100: '#bbf7d0',
    brand50: '#dcfce7', brand25: '#f0fdf4',
    bgPrimary: '#052e16', bgCard: '#14532d', bgInput: '#0d3b1e',
    bgSurface: '#166534', bgOverlay: 'rgba(5,46,22,0.92)',
    textPrimary: '#f0fdf4', textSecondary: '#bbf7d0', textMuted: '#86efac',
    border: '#166534', danger: '#f87171', warning: '#fbbf24',
    success: '#4ade80', white: '#ffffff', black: '#000000',
};

export const statusColor = (status) => {
    switch (status) {
        case 'active': case 'confirmed': case 'paid':
            return { bg: '#14532d', text: '#4ade80', border: '#166534' };
        case 'pending': case 'received':
            return { bg: '#422006', text: '#fbbf24', border: '#92400e' };
        case 'cancelled':
            return { bg: '#450a0a', text: '#f87171', border: '#7f1d1d' };
        case 'used':
            return { bg: '#1e1b4b', text: '#a5b4fc', border: '#3730a3' };
        default:
            return { bg: '#166534', text: '#86efac', border: '#166534' };
    }
};

export const categoryEmoji = (cat) => {
    const map = {
        concert: '🎵', sports: '⚽', festival: '🎪', theater: '🎭',
        comedy: '😂', conference: '🎤', exhibition: '🖼', food: '🍽',
        charity: '❤️', other: '🎟', economy: '💺', business: '👔',
        first: '⭐', premium: '✨', standard: '🎫', vip: '💎',
    };
    return map[cat?.toLowerCase()] || '🎟';
};
